import React from "react";
import { Pie } from "react-chartjs-2";
import { ThemeType } from "../../types/index";
import { useOptions, useRoundData } from "../../hooks/useGraph";
import { dummyData } from "../../contains/dummyData";
import { DataType } from "../../types/dataType";

export type PieChartProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
  data: DataType;
  theme?: ThemeType;
};

export const PieChartDefaultProps = {
  data: dummyData,
};

const PieChart = ({
  data,
  className,
  height,
  width,
  theme,
}: PieChartProps): JSX.Element => {
  const opt = useOptions("doughnut", theme);
  const chartData = useRoundData(data);

  return (
    <Pie
      data={chartData}
      className={className}
      options={opt}
      height={height}
      width={width}
    />
  );
};

PieChart.defaultProps = PieChartDefaultProps;

export default PieChart;
